import { IGroupSpace, IGroupSpaceResource } from "@sol/sdk";
import { IApiMutationFunction, createApiMutationHook } from "@sol/sdk/utils/api";
import { RelationalValue, mapRelationalValue } from "@sol/sdk/utils/filters";

export type IGroupSpaceDeleteMutationParameters = {
    groupSpace?: RelationalValue<IGroupSpaceResource>;
};

export type IGroupSpaceDeleteMutationResult = IGroupSpace;

export const groupSpaceDeleteMutation: IApiMutationFunction<IGroupSpaceDeleteMutationParameters> = ({ groupSpace }) => {
    return {
        method: "DELETE",
        url: `/group_spaces/${mapRelationalValue(groupSpace)}`,
    };
};

export const useGroupSpaceDeleteMutation = createApiMutationHook<
    IGroupSpaceDeleteMutationParameters,
    IGroupSpaceDeleteMutationResult
>(groupSpaceDeleteMutation);
